import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, NgForm } from '@angular/forms';
import { UploaderOptions, UploadOutput } from 'ngx-uploader';
import { PerformanceObjective } from '../../models/PerformanceObjective';
import { EmployeeObjectiveStatisticsServiceService } from '../../services/employee-objective-statistics-service.service';
import { EmployeePerformanceObjectivesSingletonService } from '../../services/employee-performance-objectives-singleton.service';
import { ObjectiveService } from '../../services/objective-service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-employee-performance-objective-edit',
  templateUrl: './employee-performance-objective-edit.component.html',
  styleUrls: ['./employee-performance-objective-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployeePerformanceObjectiveEditComponent implements OnInit, OnDestroy {

  @Input() set objective(objective: PerformanceObjective) {
    this.originalObjective = objective;
    this.mutableObjective = Object.assign({}, objective);

    if (!this.mutableObjective.attachments) {
      this.subscriptions.push(
        this.objectiveService.getObjectiveAttachments(this.originalObjective.objectiveId, this.completedConversation).subscribe((attachments) => {
          this.mutableObjective.attachments = attachments
          objective.attachments = attachments;
          this.cdr.markForCheck();
        })
      );
    }
  }

  @Input() isExisting: boolean;

  @Input() onSave: EventEmitter<void>;

  //TODO, get rid of this.
  @Input() showWeight: boolean;

  @Input() requiredWeight: boolean;

  @Input() completedConversation: number;

  @ViewChild(NgForm) form: NgForm;

  public mutableObjective: PerformanceObjective;
  public options: UploaderOptions = { concurrency: 1 };

  private originalObjective: PerformanceObjective;
  private subscriptions: Subscription[] = [];

  constructor(
    public objectiveSingleton: EmployeePerformanceObjectivesSingletonService,
    private employeeObjectiveStatisticsService: EmployeeObjectiveStatisticsServiceService,
    private objectiveService: ObjectiveService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

  }


  public categoryValidator(categoryControl: AbstractControl, objective: PerformanceObjective) {
    if (!categoryControl || !objective || !this.objectiveSingleton.settings.limitedOnCategory)
      return;

    const statistics = this.objectiveSingleton.statisticsMap.get(objective.categoryId);
    const { totalWeight, totalObjectives } = this.employeeObjectiveStatisticsService.getWeightAndTotalFromStatistic(statistics, this.objectiveSingleton.settings);

    this.setError(categoryControl, "categoryMaxReached", statistics?.maxNumber > 0 && totalObjectives >= statistics?.maxNumber && !(this.isExisting && this.originalObjective.categoryId == this.mutableObjective.categoryId))
  }

  public weightValidator(weightControl: AbstractControl, objective: PerformanceObjective) {
    if (!weightControl || !objective || !this.objectiveSingleton.settings.limitedOnCategory)
      return;

    const statistics = this.objectiveSingleton.statisticsMap.get(objective.categoryId);
    const { totalWeight, totalObjectives } = this.employeeObjectiveStatisticsService.getWeightAndTotalFromStatistic(statistics, this.objectiveSingleton.settings);

    const weight = parseInt(objective.weight as any);
    const calculatedWeight = (weight + totalWeight) - (this.isExisting ? this.originalObjective.weight : 0)

    this.setError(weightControl, "tooMuchWeight", weight && statistics?.maxWeight > 0 && calculatedWeight > statistics?.maxWeight)
  }

  public deletePerformanceObjectiveAttachment(attachmentId: number, objective: PerformanceObjective): void {
    objective.attachments = objective.attachments.filter(
      (att) => att.objectiveAttachmentId !== attachmentId
    );
  }

  public onUpload(output: UploadOutput, objective: PerformanceObjective): void {
    if (!objective.attachments)
      objective.attachments = [];

    switch (output.type) {
      case 'addedToQueue':
        if (typeof output.file !== 'undefined') {
          const fakeId = (objective?.attachments?.length <= 0 ? 0 : Math.max(...objective.attachments.map(a => a.objectiveAttachmentId))) + 1;

          objective.attachments.push({
            objectiveAttachmentId: fakeId,
            fileName: output.file.name,
            canDelete: true,
            objectiveId: 0,
            uploadedByKind: 0,
            uploadedById: 0,
            uploader: '',
            contentType: '',
            fileData: '',
            fileSize: '',
            file: output.file.nativeFile
          });
        }
        break;
      case 'removed':
        // remove file from array when removed
        //objective.
        break;
    }
  }

  ngOnDestroy(): void {
    for (const subscr of this.subscriptions) {
      subscr.unsubscribe();
    }
  }

  private setError(control: AbstractControl, key: string, value: boolean) {
    if (value) {
      const errors = control.errors || {};

      errors[key] = value;

      control.setErrors(errors);
    } else if (control.errors) {
      delete control.errors[key];

      if (Object.keys(control.errors).length === 0)
        control.setErrors(null)
    }
  }

}
